import { defaultFlushContext } from './flush-context';
export function createObservable(options = {}) {
    return {
        observers: [],
        observerSlots: [],
        version: 0,
        refresh: options.refresh,
        onEmpty: options.onEmpty,
    };
}
export function createObserver(notify, invalidate) {
    return {
        notify,
        invalidate,
        flushContext: defaultFlushContext,
        sources: [],
        sourceSlots: [],
        sourceVersions: [],
        trackingIndex: 0,
        trackingSources: new Map(),
    };
}
export function markChanged(observable) {
    observable.version += 1;
}
export function beginTracking(observer) {
    observer.trackingIndex = 0;
    observer.trackingSources.clear();
}
export function trackDependency(observer, observable) {
    if (!observer) {
        return;
    }
    const trackingIndex = observer.trackingIndex;
    const currentSource = observer.sources[trackingIndex];
    if (currentSource === observable) {
        observer.trackingSources.set(observable, trackingIndex);
        observer.sourceVersions[trackingIndex] = observable.version;
        observer.trackingIndex += 1;
        return;
    }
    if (observer.trackingSources.has(observable)) {
        return;
    }
    if (currentSource) {
        detachSourceAt(observer, trackingIndex);
    }
    const observableSlot = observable.observers.length;
    if (trackingIndex < observer.sources.length) {
        observer.sources[trackingIndex] = observable;
        observer.sourceSlots[trackingIndex] = observableSlot;
        observer.sourceVersions[trackingIndex] = observable.version;
    }
    else {
        observer.sources.push(observable);
        observer.sourceSlots.push(observableSlot);
        observer.sourceVersions.push(observable.version);
    }
    observable.observers.push(observer);
    observable.observerSlots.push(trackingIndex);
    observer.trackingSources.set(observable, trackingIndex);
    observer.trackingIndex += 1;
}
export function endTracking(observer) {
    while (observer.sources.length > observer.trackingIndex) {
        const lastIndex = observer.sources.length - 1;
        detachSourceAt(observer, lastIndex);
        observer.sources.pop();
        observer.sourceSlots.pop();
        observer.sourceVersions.pop();
    }
    observer.trackingSources.clear();
}
export function cleanupObserver(observer) {
    while (observer.sources.length > 0) {
        const lastIndex = observer.sources.length - 1;
        detachSourceAt(observer, lastIndex);
        observer.sources.pop();
        observer.sourceSlots.pop();
        observer.sourceVersions.pop();
    }
    observer.trackingIndex = 0;
    observer.trackingSources.clear();
}
export function needsObserverRefresh(observer) {
    for (let index = 0; index < observer.sources.length; index += 1) {
        const source = observer.sources[index];
        source.refresh?.();
        if (source.version !== observer.sourceVersions[index]) {
            return true;
        }
    }
    return false;
}
function detachSourceAt(observer, sourceIndex) {
    const observable = observer.sources[sourceIndex];
    const observableSlot = observer.sourceSlots[sourceIndex];
    if (!observable) {
        return;
    }
    removeObserverAt(observable, observableSlot);
}
function removeObserverAt(observable, observerIndex) {
    const lastIndex = observable.observers.length - 1;
    if (observerIndex < 0 || observerIndex > lastIndex) {
        return;
    }
    const lastObserver = observable.observers[lastIndex];
    const lastObserverSourceSlot = observable.observerSlots[lastIndex];
    if (observerIndex !== lastIndex) {
        observable.observers[observerIndex] = lastObserver;
        observable.observerSlots[observerIndex] = lastObserverSourceSlot;
        lastObserver.sourceSlots[lastObserverSourceSlot] = observerIndex;
    }
    observable.observers.pop();
    observable.observerSlots.pop();
    if (observable.observers.length === 0) {
        observable.onEmpty?.();
    }
}
export function syncSourceVersions(observer) {
    for (let index = 0; index < observer.sources.length; index += 1) {
        observer.sourceVersions[index] = observer.sources[index].version;
    }
}
export function clearObserverState(observer) {
    observer.sources.length = 0;
    observer.sourceSlots.length = 0;
    observer.sourceVersions.length = 0;
    observer.trackingIndex = 0;
    observer.trackingSources.clear();
}
//# sourceMappingURL=graph.js.map